<template>
  <div>
    <div class="bg-white border-bottom border-gray">
      <b-container fluid>
        <payroll-clasification lazy
          @submit-button-clicked="loadEmployees"
        >
        </payroll-clasification>
      </b-container>
    </div>
    <b-container fluid>
      <payroll-table class="my-3" :employees="employees" :fields="fields"></payroll-table>
    </b-container>  
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import PayrollClasification from '../components/common/PayrollClasification.vue';
import PayrollTable from '../components/payroll/PayrollTable.vue';

export default {
  components: {
    PayrollClasification,
    PayrollTable
  },
  computed: {
    ...mapState('payroll', [
      'employees'
    ]),
    ...mapGetters('payroll', [
      'fields'
    ])
  },
  methods: {
    ...mapActions('payroll', [
      'loadEmployees'
    ])
  }
}
</script>
